<template>
  <div class="base-file-drop">
    <div 
      ref="dropZone" 
      class="base-file-drop__zone" 
      @submit.prevent
    >
      <base-spinner />
      <input 
        class="base-file-drop__input" 
        type="file"
      >
    </div>
  </div>
</template>

<script>
export default {
  name: "BaseFileDrop",
};
</script>

<style lang="scss" scoped>
@import "./base-file-drop.scss";
</style>
